// extracted by extract-css-chunks-webpack-plugin
module.exports = {"quote":"css-x9A2G47lxO","quote_content":"css-2G6CXXnnOz","quote_cite":"css-3XW8N0fJsO"};